Vue.component('burger', {
	template: '<div class="Burger">' +
                '<a class="Burger__link" v-on:click="toggleVisibility"></a>' +
                '<span class="Burger__icon"></span>' +
              '</div>',
	methods:{
		toggleVisibility: function(){
			document.body.classList.toggle('burger-is-open')
		}
	}
});